module.exports = __webpack_public_path__ + "media/images/dashboard/purebarre_banner_card-689a56d515ce769ac9342e57b093f8cc.jpg";